import React from 'react';
import { motion } from 'framer-motion';
import { 
  Megaphone, Music, Video, FileEdit, PhoneCall, Radio, 
  Globe, Smartphone, Palette, ArrowUpRight, Zap 
} from 'lucide-react';
import styles from './OtherServices.module.css';

const OtherServices = () => {
  const brandOrange = "#e87355";
  const brandBlue = "#5ba5e0";

  return (
    <section className={styles.section}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <div className={styles.badge}>BEYOND NEWS</div>
          <h2 className={styles.title}>Explore Our <span className={styles.accent}>Digital Ecosystem</span></h2>
          <p className={styles.subtitle}>Scaling your brand and influence with cutting-edge technology.</p>
        </div>

        <div className={styles.grid}>
          
          {/* --- SERVICE 1: ELECTION CAMPAIGNING --- */}
          <motion.div 
            className={`${styles.card} ${styles.electionCard}`}
            whileHover={{ y: -10 }}
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className={styles.cardHeader}>
              <div className={styles.iconCircle} style={{ background: `${brandOrange}20` }}>
                <Megaphone color={brandOrange} size={32} />
              </div>
              <div>
                <h3 className={styles.cardTitle}>ANANTA <br /><span>Election Campaigning</span></h3>
              </div>
            </div>

            <p className={styles.cardDesc}>Dominate the digital battlefield with AI-driven political strategy and high-impact outreach.</p>

            <div className={styles.servicesGrid}>
              <div className={styles.serviceItem}><Video size={18} /> AI Campaign Videos</div>
              <div className={styles.serviceItem}><Music size={18} /> Custom Campaign Songs</div>
              <div className={styles.serviceItem}><Radio size={18} /> Prachar Gadi Audio</div>
              <div className={styles.serviceItem}><FileEdit size={18} /> Expert Copywriting</div>
              <div className={styles.serviceItem}><PhoneCall size={18} /> AI Bulk Calling</div>
              <div className={styles.serviceItem}><Zap size={18} /> Targetted Election Ads</div>
            </div>

            <button className={styles.cardBtn} style={{ background: brandOrange }}>
              Win Your Election <ArrowUpRight size={18} />
            </button>

            {/* Decorative BG Icon */}
            <Megaphone className={styles.bgIcon} size={120} style={{ color: `${brandOrange}08` }} />
          </motion.div>

          {/* --- SERVICE 2: INFOTECH --- */}
          <motion.div 
            className={`${styles.card} ${styles.infoCard}`}
            whileHover={{ y: -10 }}
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className={styles.cardHeader}>
              <div className={styles.iconCircle} style={{ background: `${brandBlue}20` }}>
                <Globe color={brandBlue} size={32} />
              </div>
              <div>
                <h3 className={styles.cardTitle}>ANANTA <br /><span>Infotech Solutions</span></h3>
              </div>
            </div>

            <p className={styles.cardDesc}>Building robust digital infrastructure with premium design and high-performance engineering.</p>

            <ul className={styles.infoList}>
              <li className={styles.listItem}>
                <Globe color={brandBlue} size={22} />
                <div>
                  <strong>Website Development</strong>
                  <p>Next-gen responsive web applications.</p>
                </div>
              </li>
              <li className={styles.listItem}>
                <Smartphone color={brandBlue} size={22} />
                <div>
                  <strong>App Development</strong>
                  <p>Native & Hybrid mobile experiences.</p>
                </div>
              </li>
              <li className={styles.listItem}>
                <Palette color={brandBlue} size={22} />
                <div>
                  <strong>Graphic Designing</strong>
                  <p>Brand identity & high-conversion visuals.</p>
                </div>
              </li>
            </ul>

            <button className={styles.cardBtn} style={{ background: brandBlue }}>
              Scale Your Tech <ArrowUpRight size={18} />
            </button>

            {/* Decorative BG Icon */}
            <Globe className={styles.bgIcon} size={120} style={{ color: `${brandBlue}08` }} />
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default OtherServices;